// Polyfills for older Safari / iOS browsers (must be first)
import 'react-app-polyfill/ie11';
import 'react-app-polyfill/stable';
import 'globalthis/auto';
// Intl.PluralRules polyfill for i18next on older Safari/iOS
import '@formatjs/intl-pluralrules/polyfill.js';
import '@formatjs/intl-pluralrules/locale-data/en.js';
import '@formatjs/intl-pluralrules/locale-data/it.js';

// Safari (and some iOS WKWebViews) don't implement addEventListener on
// MediaQueryList. Some Capacitor builds even hide window.MediaQueryList
// entirely, so prototype patching alone is unreliable. We patch the
// prototype if available AND wrap matchMedia so every returned MQL is
// fixed in place. framer-motion v12's prefers-reduced-motion check calls
// mql.addEventListener("change", ...) and crashes the entire React tree
// on iOS WKWebView without this shim.
if (typeof window !== 'undefined' && typeof window.matchMedia === 'function') {
  try {
    const fixMQL = (mql) => {
      if (!mql || typeof mql !== 'object') return mql;
      if (typeof mql.addEventListener !== 'function' && typeof mql.addListener === 'function') {
        mql.addEventListener = function (type, listener) { this.addListener(listener); };
      }
      if (typeof mql.removeEventListener !== 'function' && typeof mql.removeListener === 'function') {
        mql.removeEventListener = function (type, listener) { this.removeListener(listener); };
      }
      return mql;
    };
    // 1) Patch prototype if exposed.
    const mqlProto = window.MediaQueryList && window.MediaQueryList.prototype;
    if (mqlProto && typeof mqlProto.addEventListener !== 'function' && typeof mqlProto.addListener === 'function') {
      mqlProto.addEventListener = function (type, listener) { this.addListener(listener); };
      mqlProto.removeEventListener = function (type, listener) { this.removeListener(listener); };
    }
    // 2) Wrap matchMedia so every future MQL is patched even if the
    //    constructor/prototype is not accessible (Capacitor WKWebView quirk).
    const _origMatchMedia = window.matchMedia.bind(window);
    window.matchMedia = function (query) {
      return fixMQL(_origMatchMedia(query));
    };
  } catch (err) {
    // fail silently — polyfill is best-effort
    console.warn('MediaQueryList addEventListener polyfill failed', err);
  }
}

import React from "react";
import ReactDOM from "react-dom/client";
import { HelmetProvider } from 'react-helmet-async';
import "@/index.css";
import App from "@/App";
import { initFileLogger } from "@/lib/fileLogger";

// Kick off the on-device file logger as early as possible so we capture
// boot-time console output. Fire-and-forget — we never want logging to
// block the render path.
initFileLogger().catch(() => { /* swallow */ });

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <HelmetProvider>
      <App />
    </HelmetProvider>
  </React.StrictMode>,
);
